import { APP_ENV } from '../api';

type EnvBadge = { text: string; className: string; title: string };

function getEnvBadge(env: string): EnvBadge | null {
  const v = (env || 'local').toLowerCase();
  if (v === 'production') return null;
  if (v === 'staging' || v === 'green') {
    return {
      text: 'GREEN',
      className: 'bg-[var(--neo-mint)] text-black',
      title: 'GREEN',
    };
  }
  // local 및 기타(예: development)
  return {
    text: 'LOCAL',
    className: 'bg-[var(--neo-orange)] text-black',
    title: 'LOCAL',
  };
}

export default function EnvironmentBadge() {
  const badge = getEnvBadge(APP_ENV);
  if (!badge) return null;
  return (
    <span
      className={`neo-badge text-[9px] px-1.5 py-0.5 ${badge.className}`}
      title={badge.title}
      data-testid="env-badge"
    >
      {badge.text}
    </span>
  );
}


